import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=8b266190&functional=true"
var script = {}
import style0 from "./VSelect.vue?vue&type=style&index=0&id=8b266190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports